import {Injectable} from "@angular/core";
import {CashHardwarePort} from "../../domain/ports/cash-hardware.port";
import {HardwareManagerService} from "../../../core/services/hardware-manager/hardware-manager.service";
import {first, map, Observable} from "rxjs";

@Injectable()
export class CashHardwareAdapter implements CashHardwarePort {
  constructor(private readonly hardwareManagerService: HardwareManagerService) {
  }

  openDrawer(): Observable<void> {
    return this.hardwareManagerService.openCashDrawer()
      .pipe(
        first(),
        map(() => void 0));
  }
}
